import { BadgeStateType } from '@vst/beam';

export interface NavigationHandlers {
  navigateToPreviousPage: () => void;
  navigateToOverview: () => void;
}

export enum AddonProductTypeIds {
  SHIELD = '49162977-8ebf-460b-8908-368ee1f8673d',
  STREAM = 'd46ae641-7779-42e5-ba5e-479ef09648c5',
  STATIC_IP = '77a013f1-6947-4045-939d-67ec292e78ef',
  EASY_CARE = '52df7cdd-5678-43f0-89fd-74445d69b9e0',
  EASY_CARE_BUNDLED = 'b739502e-cdf0-4e81-a973-83a85db802ec',
  CYBER_PROTECT = 'd3a58365-e299-4c7f-8f84-463911ad6985',
}

export interface BadgeProps {
  state?: BadgeStateType;
  style?: Record<string, string>;
}

export type ModalTypes = 'terms&conditions' | 'calculationModal';

export enum Variant {
  DEFAULT = 'default',
  BLUE = 'blue',
}

export type StylesWithCSSVariable = React.CSSProperties & {
  '--collapsible-current-plan-height': string;
  '--navigation-header-height': string;
};

export enum RouterText {
  Voice = 'Voice',
  Internet = 'Internet',
}

export enum DirectiveCharacteristics {
  OnCallDirective = 'POP-UP',
}

export enum FamilyPlan {
  BusinessCAF = 'Business CAF',
  BusinessChoice = 'Business Choice',
  CAFII = 'CAF II',
}
